import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import * as actions from './state/actions';

import ImportSiteForm from './components/ImportSiteForm';
import FileSpecs from './components/FileSpecs';
import { NotificationMessage } from 'Components';
import { Filter, Main } from '../../containers/';
import { IMPORT_SITE_FORM_NAME } from 'Common/FormEnum';

import 'PageStyles/importsite/index.less';

class ImportSiteContainer extends Component {
  componentWillUnmount() {
    toast.dismiss();
  }

  componentDidUpdate(prevProps) {
    const { importSite } = this.props;

    if (prevProps.importSite !== importSite) {
      if (importSite.Errors && importSite.Errors.length > 0) {
        NotificationMessage(importSite, true);
      }
    }
  }

  handleSubmit = data => {
    this.props.clearImportSiteErrors();
    this.props.clearImportSiteData();

    if (data.import_file === undefined || data.import_file.length === 0) {
      this.props.setImportSiteErrors('Please choose a file.');
      return;
    }

    if (data.import_file[0].size > 1000000) {
      this.props.setImportSiteErrors('File size must be less than 1MB.');
      return;
    }

    let formData = new FormData();
    formData.append('name', data.name);
    formData.append('import_file', data.import_file[0]);

    this.props.postImportSiteFile(formData);
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        formName: IMPORT_SITE_FORM_NAME,
        saveButtonProps: {
          content: 'Submit',
        },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Import Sites'} />
        <Main {...this.getMainProps()}>
          <ImportSiteForm
            onSubmit={this.handleSubmit}
            initialValues={{ file_name: '', import_file: undefined }}
            clearImportSiteErrors={this.props.clearImportSiteErrors}
            isReadOnly={this.props.isReadOnly}
          />
          <FileSpecs />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ImportSiteState }) => {
  return {
    importSite: ImportSiteState.importSite,
  };
};

export const ImportSite = withRouter(
  connect(
    mapStateToProps,
    actions
  )(ImportSiteContainer)
);



// WEBPACK FOOTER //
// ./src/pages/importsite/ImportSite.js